export type StripeConfig = {
    publishableKey: string;
    paymentMethodConfigurationId: string;
};

const PROD_STRIPE_CONFIGURATION_BY_CURRENCY: Record<string, StripeConfig> = {
    AUD: {
        publishableKey:
            'pk_live_51PNdJHPEztQSV80vMD768GH4fw4cIoey4bjpVR8uvCFC0IesD5YmT4npUSM0RqhFCwYA0hlpaetYpp5a0eTTh56W00cJJE4l1d',
        paymentMethodConfigurationId: 'pmc_1Qquo5PEztQSV80v8TSkVgdv',
    },
    USD: {
        publishableKey:
            'pk_live_51MMINkAScGs1SMDZLIRSnsvGULcl0sgVTIfeFgJ3i4j39sYE5ZJTmSqdzWYpulWQViCBCjOd4kvlQhgTKzKDAA5V00Kmgn5wQm',
        paymentMethodConfigurationId: 'pmc_1RHlmmAScGs1SMDZkCpjnszn',
    },
    CAD: {
        publishableKey:
            'pk_live_51O5D2HLXxt5f3o3fDl6pDmi5mUi4eDeIjhr7I6qhagLvJL2dc9KhxNqgKaWhfQx6hiPWhKwtk82YqGqI7QxPQhQn002snHN7GR',
        paymentMethodConfigurationId: 'pmc_1RHSXPLXxt5f3o3flrOjGUdd',
    },
    NZD: {
        publishableKey:
            'pk_live_51Qs8wQPSDmU20I4X8Qd1lmU9JqgrITFoNqMfGTUx2eDPa8UdQ9CmcyrBpFSEOQVVvslesftbvtw48YJFIT4Z1cU400feZMzEKT',
        paymentMethodConfigurationId: 'pmc_1RQNwLPSDmU20I4XVvpuOcrr',
    },
};

const TEST_STRIPE_CONFIGURATION_BY_CURRENCY: Record<string, StripeConfig> = {
    AUD: {
        publishableKey:
            'pk_test_51PNdJHPEztQSV80vy1qdVg96OU2LqwLiM8oe1VAFvKK1dpChYmm04Us75vdDuTq0P0ED1n4ECrMskuyNpSkpxDr900TJvjMo6p',
        paymentMethodConfigurationId: 'pmc_1QnHZoPEztQSV80v0t9CUofy',
    },
    USD: {
        publishableKey:
            'pk_test_51MMINkAScGs1SMDZCKhf47fTAeq5WClAy1Hd37OGg42RkUTSpCzOOi8C3Yl7V5PNVlCW477kE1ilqlewBZiyNscb00jCuXkVEq',
        paymentMethodConfigurationId: 'pmc_1RHlnmAScGs1SMDZu4JVDEOw',
    },
    CAD: {
        publishableKey:
            'pk_test_51O5D2HLXxt5f3o3fv2FZo86K1SAGec2Tl4X4VxNeoxkGykUqg4uSuwWkUlzoDGfSEfxV9SR3USZGJQLjasLJCf3A00JwHydVvR',
        paymentMethodConfigurationId: 'pmc_1RHOnJLXxt5f3o3fZd93ajMI',
    },
    NZD: {
        publishableKey:
            'pk_test_51Qs8wQPSDmU20I4X02b218wqmqE8R7QSdV5OjZmk2gr0l631WgPSsxjfqJ73r8pLZFSNrJ6uoW3TkEeD1ZPw8krf001e9CP6yk',
        paymentMethodConfigurationId: 'pmc_1RQNV1PSDmU20I4XiPG79lt7',
    },
};

const TEST_STRIPE_CONFIGURATION: StripeConfig = {
    publishableKey:
        'pk_test_51Pd79RFyGVs0gTWz3qjYu4IKNriFmMpb6WJvx8jR0AQnfTuIT8vJy7MRsXFZ4zgMlq2JVkPwAZ7B3uxcCmtd9klP00VFpMRfgp',
    paymentMethodConfigurationId: 'pmc_1PdRdBFyGVs0gTWzHQXyZAVd',
};

export const getStripeConfiguration = (
    currency: string,
    isProd: boolean,
): StripeConfig | undefined => {
    if (!isProd) {
        return (
            TEST_STRIPE_CONFIGURATION_BY_CURRENCY[currency] ??
            TEST_STRIPE_CONFIGURATION
        );
    }

    return PROD_STRIPE_CONFIGURATION_BY_CURRENCY[currency];
};

export const isThereStripeConfiguration = (
    currency: string,
    isProd: boolean,
): boolean => {
    return !!getStripeConfiguration(currency, isProd);
};

export const convertFullAmountToCentAmount = (
    amount: number,
    currencyPrecision: number,
) => {
    // amount in dollars (euros, baths, whatever) multiplied by precision where precision = number of symbols after the point
    return Math.round(amount * Math.pow(10, currencyPrecision));
};
